import React, {useEffect, useState} from 'react';
import {Elements, useStripe, useElements, PaymentElement, AddressElement} from '@stripe/react-stripe-js';
import AppConfig from "../../../AppConfig";
import {useSelector} from "react-redux";
import ActivityIndicatorWrapper from "../../../components/public/UI/ActivityIndicatorWrapper";

import stripePromise from '../../../custom-packages/stripe/StripeLoader';
import {
    ActivityIndicator,
    View
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import * as MaskFunctions from "@chocostack/maskifier";
import {DarkButton, ThemeButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import {useNavigate} from "react-router-dom";

import './BillingInput.css'
import appConfig from "../../../AppConfig";
import PencilIcon from "../../../assets/custom-icons/PencilIcon";

const TBillingSettingsScreen = {
    "enUS": {
        BILLING: "Billing",
        CHANGE: "Change",
        YOU_WILL_PAY: 'You will pay ',
        MONTHLY: ' / Month',
        SAVE: 'Save',
        PAY: 'Pay',
        CHARGE_DATE: 'You will be charged on ',
        ACCEPT_TOS: 'You accept our <a href=\'/TermsOfService\' target=\'_blank\' style="font-size: 0.85rem">Terms of Service and Privacy Policy</a>',
    },
    "esMX": {
        BILLING: "Datos de Facturación",
        CHANGE: "Cambiar",
        YOU_WILL_PAY: 'Pagarás ',
        MONTHLY: ' / Mes',
        SAVE: 'Guardar',
        PAY: 'Pagar',
        CHARGE_DATE: 'El cargo se realizará a partir del ',
        ACCEPT_TOS: 'Puedes consultar nuestros <a href=\'/TermsOfService\' target=\'_blank\' style="font-size: 0.85rem">Términos de Servicio y Política de Privacidad aquí</a>',
    }
};

function BillingSettingsScreen() {
    const Auth = useSelector(state => state.Auth);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [clientSecret, setClientSecret] = useState(null);
    const [billingInfo, setBillingInformation] = useState(null);

    const options = {
        clientSecret: clientSecret,
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(AppConfig.URL + "/Subscription/StripeSetupIntent/", {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': Auth.token
                }
            });

            const json = await response.json();

            if (json.clientSecret) {
                setClientSecret(json.clientSecret);
                setBillingInformation(json.billingInformation);
                setLoading(false);
            }
        };

        fetchData();
    }, [Auth.token]);

    if (loading) return <ActivityIndicatorWrapper/>;

    return (
        <Elements stripe={stripePromise} options={options}>
            <BillingInfo
                clientSecret={clientSecret}
                handleError={setError}
                billingInformation={billingInfo}
            />
            {error && <div className="error">{error}</div>}
        </Elements>
    );
}

export default BillingSettingsScreen;

const BillingInfo = ({clientSecret, billingInformation, handleError}) => {
    const Auth = useSelector(state => state.Auth);
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [billingEditable, setBillingEditable] = useState(!billingInformation || !billingInformation.address);
    const [subData, setSubData] = useState(null);

    const [saving, setSaving] = useState(false)

    const handleSubmit = async () => {
        const redirectTarget = 'https://tastee.app/admin/settings?target=sub';
        setSaving(true)

        if (!stripe || !elements) {
            console.log('Stripe.js has not loaded yet.');
            setSaving(false)
            return;
        }

        // Assuming you want to use card payments and have a CardElement in your form
        const paymentElement = elements.getElement(PaymentElement); // Adjust this if you're using another element like PaymentElement

        if (!paymentElement) {
            console.log('CardElement was not found');
            setSaving(false)
            return;
        }

        await elements.submit()

        const response = await stripe.confirmSetup({
            // You don't need to specify payment method details here as with confirmCardSetup
            elements,
            clientSecret: clientSecret,
            redirect: "if_required",
            confirmParams: {
                // Your additional parameters here
                return_url: redirectTarget,
                payment_method_data: {
                    billing_details: billingEditable ?
                        null
                        :
                        billingInformation && billingInformation.address ?
                            {
                                name: billingInformation.name,
                                address: {
                                    line1: billingInformation.address,
                                    line2: billingInformation.line2,
                                    city: billingInformation.city,
                                    state: billingInformation.state,
                                    postal_code: billingInformation.postalCode
                                }
                            }
                            :
                            null
                }
            },
        });

        console.log(response)

        if (response.setupIntent.status == 'succeeded') {
            const finishSetupResponse = await fetch(AppConfig.URL + '/Subscription/StripeFinishSetup?paymentMethodId=' + response.setupIntent.payment_method, {
                method: 'GET',
                headers: {
                    'Authorization': Auth.token,
                    'Content-Type': 'application/json',
                },
            });

            const data = await finishSetupResponse.json()

            if (data.success) {

            }

            navigate('/admin/settings?target=sub')
        } else {
            setSaving(false)
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(AppConfig.URL + '/Subscription/FetchSubscription', {
                method: 'GET',
                headers: {
                    'Authorization': Auth.token,
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json()

            if (data.success) {
                setSubData(data.subscription);
                setLoading(false);
            }
        };

        fetchData();
    }, [Auth.token]);

    return (
        <View
            className={'row'}
        >
            <View
                className={'col-md-8'}
            >
                <View
                    className={"card"}
                    style={{marginBottom: 15}}
                >
                    <View
                        className={'card-body'}
                    >
                        <PaymentElement/>
                        <h1
                            style={{marginTop: 25}}
                        >
                            {TBillingSettingsScreen[AppConfig.lang].BILLING}
                        </h1>
                        {
                            billingEditable ?
                                <AddressElement options={{mode: 'billing'}}/>
                                :
                                <View
                                >
                                    <View
                                        style={{ marginTop: 15, flexDirection: 'row', justifyContent: 'space-between' }}
                                    >
                                        <View>
                                            <View
                                                style={{
                                                    fontSize: 20
                                                }}
                                            >
                                                {billingInformation.address}
                                            </View>
                                            <View
                                                style={{
                                                    fontSize: 20
                                                }}
                                            >
                                                {billingInformation.line2}
                                            </View>
                                            <View
                                                style={{
                                                    fontSize: 20
                                                }}
                                            >
                                                {billingInformation.city},{" "}
                                                {billingInformation.state}
                                            </View>
                                            <View
                                                style={{
                                                    marginTop: 15,
                                                    fontSize: 20,
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {billingInformation.name}
                                            </View>
                                        </View>
                                        <View>
                                            <ThemeButton
                                                icon={<PencilIcon  color={'white'} />}
                                                text={TBillingSettingsScreen[AppConfig.lang].CHANGE}
                                                onPress={() => {
                                                    setBillingEditable(true)
                                                }}
                                            />
                                        </View>
                                    </View>
                                </View>
                        }
                    </View>
                </View>
            </View>
            <View
                className={'col-md-4'}
            >
                <View
                    className={"card"}
                >
                    <View
                        className={'card-body'}
                    >
                        {
                            loading ?
                                <ActivityIndicator/>
                                :
                                <View>
                                    <View>
                                        <strong
                                            style={{
                                                fontSize: 26,
                                                textAlign: 'center'
                                            }}
                                        >
                                            {MaskFunctions.maskMoney(
                                                subData.subscriptionPrice.spR_PRICE
                                                +
                                                (
                                                    (subData.subscriptionPrice.businessSubscription.bsU_QUANTITY - 1)
                                                    *
                                                    subData.subscriptionPrice.spR_PRICE_INCREMENT
                                                )
                                            )}
                                            {' ' + subData.subscriptionPrice.spR_CURRENCY}
                                            {TBillingSettingsScreen[AppConfig.lang].MONTHLY}
                                        </strong>
                                        {
                                            subData.subscriptionPrice.businessSubscription.expired ?
                                                null
                                                :
                                                <div
                                                    style={{
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    {TBillingSettingsScreen[AppConfig.lang].CHARGE_DATE}
                                                    <strong>
                                                        {subData.subscriptionPrice.businessSubscription.formattedExpiration}
                                                    </strong>
                                                </div>
                                        }
                                        <div
                                            style={{
                                                marginTop: 15,
                                                textAlign: 'center',
                                                fontSize: '.85rem',
                                                color: '#6d6e78'
                                            }}
                                            dangerouslySetInnerHTML={{ __html: TBillingSettingsScreen[AppConfig.lang].ACCEPT_TOS }}
                                        >
                                        </div>
                                    </View>
                                    <ThemeButton
                                        disabled={saving}
                                        text={
                                            saving ?
                                                <ActivityIndicator
                                                    style={{alignSelf: 'center'}}
                                                    size="20"
                                                    color="#FFF"
                                                />
                                                :
                                                subData.subscriptionPrice.businessSubscription.expired ?
                                                    TBillingSettingsScreen[AppConfig.lang].PAY
                                                    :
                                                    TBillingSettingsScreen[AppConfig.lang].SAVE
                                        }
                                        onPress={handleSubmit}
                                        style={{marginTop: 15}}
                                    />
                                </View>
                        }
                    </View>
                </View>
            </View>
        </View>
    );
};